import styled, { ThemeProps } from 'styled-components';
import { Theme } from './types';
import { colors } from './colors';

export const DividerLine = styled.div`
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'light' ? colors.greyUltraLight : colors.greyDark};
  width: 100%;
  height: 1px;
`;

export const DividerLineVertical = styled.div`
  background-color: ${(props: ThemeProps<Theme>) =>
    props.theme.name === 'light' ? colors.greyUltraLight : colors.greyDark};
  height: 100%;
  width: 1px;
`;
